import React from 'react';
import '../../styles/components/project-card.scss';
import { formatAmount } from '../../utils/common';
import i18n from '../../i18n';

class ProjectCard extends React.Component {
  render() {
    const { icon: Icon, className, title, value, amount, onClick } = this.props;
    const cardClass = `project-card  ${className}`;

    return (
      <div className={cardClass} onClick={onClick}>
        <div className="project-card-body">
          <div className={`project-card-icon ${className}`}>
            <Icon size={24} />
          </div>
          <div className="project-card-text">
            <div className="project-header">{title}</div>

            {amount !== undefined && <div className="project-amount">{formatAmount(amount)}</div>}
            <div className="project-value">
              {value} {i18n.t('auctions')}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProjectCard;
